import { useState } from "react"
import DotsLoader from "components/DotsLoader"
import useInterval from "hooks/useInterval"

interface Props {
  inline?: boolean
}

const Loading = ({ inline = false }: Props) => {
  const [visible, setVisible] = useState(false)

  useInterval(() => {
    setVisible(true)
  }, 400)

  if (!visible) return null

  if (inline) {
    return (
      <div className="flex items-center gap-2 text-gallery-muted">
        <DotsLoader compact hideLabel label="Loading" />
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center py-24">
      <DotsLoader label="Loading" />
    </div>
  )
}

export default Loading
